import { Swiper } from 'swiper'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

Swiper.use([Pagination])
Swiper.use([Autoplay])
Swiper.use([Navigation])

export default () => ({
    carousel: null,

    init() {
        this.carousel = new Swiper('.swiper-hero-carousel-instance', {
            slidesPerView: 1,
            speed: 3500,
            effect: 'fade',
            centeredSlides: false,
            loop: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            autoplay: {
                delay: 1000,
                disableOnInteraction: false,
            },
        })
    },
})
